import { OptionSelect } from './option-select'

export default OptionSelect
